export default {"src":"/_next/static/media/nature-relaxation.mono.0a37429a.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};